import { NavigationSubItem } from "../navigation-item"

export class DocsMoreSubItem extends NavigationSubItem {
  readonly id = "docs"
  readonly label = "Docs"
  readonly href = "/docs"
  readonly iconName = "docs-icon"
  readonly isExternal = false
  readonly tabs = []
}
